var map = {
	"./bg-uuva-cloud.jpg": "./src/assets/backgrounds/bg-uuva-cloud.jpg",
	"./bg_brang.jpg": "./src/assets/backgrounds/bg_brang.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/backgrounds sync recursive ^\\.\\/.*\\.jpg$";